export default __webpack_public_path__ + "static/Uniswap-fe1a7fa6ef3ce024ddb33b890395095c.png";